
interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-6 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img 
            src="https://public.readdy.ai/ai/img_res/ebcdf7a9-2e92-462c-8afb-73f0da2ccf5f.png" 
            alt="JAMNIK d.o.o. Logo" 
            className="h-10 w-auto object-contain"
          />
          <span className={`text-lg font-medium transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
            JAMNIK d.o.o.
          </span>
        </div>
        <ul className="flex items-center gap-10">
          {['Home', 'About', 'Products', 'Features', 'Contact'].map((item) => (
            <li key={item}>
              <button
                onClick={() => scrollToSection(item.toLowerCase())}
                className={`text-sm uppercase tracking-wider transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? 'text-gray-600 hover:text-gray-900'
                    : 'text-white/60 hover:text-white'
                }`}
              >
                {item}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}